import { Modal } from '@/components/ui/Modal';
import { SHORTCUTS } from '@/hooks/useGlobalShortcuts';

const isMac = typeof navigator !== 'undefined' && navigator.platform.startsWith('Mac');

export function ShortcutsModal({ onClose }: { onClose: () => void }) {
  return (
    <Modal open onClose={onClose} title="Keyboard shortcuts" size="lg">
      <div className="grid gap-6 md:grid-cols-2">
        {SHORTCUTS.map((group) => (
          <section key={group.group}>
            <h3 className="mb-2 text-xs font-bold tracking-wider text-fg-muted uppercase">{group.group}</h3>
            <ul className="divide-y divide-line rounded-xl border border-line bg-sidebar">
              {group.items.map((item) => (
                <li key={item.description} className="flex items-center justify-between gap-4 px-3 py-2.5 text-sm">
                  <span className="text-fg-soft">{item.description}</span>
                  <span className="flex shrink-0 items-center gap-1">
                    {item.keys.map((key) => (
                      <kbd key={key} className="min-w-6 rounded-md border border-line-strong bg-elevated px-1.5 py-0.5 text-center font-mono text-xs text-fg shadow-[0_1px_0_var(--clanfire-border-strong)]">
                        {isMac && key === 'Ctrl' ? '⌘' : key}
                      </kbd>
                    ))}
                  </span>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </Modal>
  );
}
